import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { LoadCarrierList } from "@msuite/utils/types";
import { client } from "@/hono";

export function useLoadCarriers() {
	/** Query */
	const query = useQuery({
		queryKey: ["load-carriers"],
		queryFn: async () => {
			const response = await client.stock["load-carriers"].$get();
			const data = await responseHandler(response);
			return data.loadCarriers as LoadCarrierList;
		},
	});

	/** Return */
	return { ...query, loadCarriers: (query.data || []) as LoadCarrierList };
}
